import { Model } from '@psyomics/surveyjs-core';

import { Survey, SurveySet, SurveySetWithoutModel, AnswersByRespondentType } from '../survey-types';
import { MemoryCache } from '../utils/memory-cache';

const surveyModelCache = new MemoryCache<Model>();

const processSurveys = (surveySet: SurveySetWithoutModel, answers: AnswersByRespondentType): SurveySet => {
  return surveySet
    .map((survey) => {
      const model = surveyModelCache.getOrCreate({
        id: survey.id,
        name: survey.name,
        content: survey.definition,
        factory: (definition) => new Model(definition),
      });

      if (answers) {
        model.data = answers[survey.respondentType];
      }

      return { ...survey, model };
    })
    .filter((survey): survey is Survey => Boolean(survey));
};

export { processSurveys };
